module.exports = __webpack_public_path__ + "img/snax.03587fe3.png";